/**
 * Tenant team/user management contract shared by the API and the web client.
 * Kept in sync with apps/api/src/modules/users/users.schemas.ts.
 */
/**
 * The platform's fixed system roles (docs/DATABASE.md - `roles` where
 * `tenant_id IS NULL`). There is no tenant-custom-role support yet, so
 * every assignable role comes from this fixed list.
 */
export const SYSTEM_ROLES = [
    { name: 'OWNER', description: 'Full access to everything in the tenant, including billing.' },
    { name: 'ADMIN', description: 'Full operational and administrative access.' },
    {
        name: 'MANAGER',
        description: 'Manages CRM, conversations and automation for the whole team.',
    },
    { name: 'SALES', description: 'Works contacts, leads, pipelines and conversations.' },
    { name: 'SUPPORT', description: 'Works conversations, tasks and contact context.' },
    { name: 'VIEWER', description: 'Read-only access.' },
];
//# sourceMappingURL=users.js.map